import { gql } from '@apollo/client';

export const GET_CB_SETTINGS = gql`
  query GetCbSettings($input: GetCbSettingsInput!) {
    getCbSettings(input: $input) {
      __typename
      id
      type
      agencyId
      campaignType
      ... on CbInviteProcessingFeeSetting {
        inviteProcessingFee
      }
      ... on CbProcessingFeeSetting {
        launchFee
      }
      ... on CbFeeSetting {
        launchFee
      }
      ... on CbPitchSetting {
        pitch
        isRequired
      }
      ... on CbLockSetting {
        durationSeconds
      }
      ... on CbDeliverableRevisionLimitSetting {
        revisionLimit
      }
      ... on CbDigitalAgreementSetting {
        enabled
      }
      ... on CbAgencySignUpEmailVerificationSetting {
        enabled
      }
    }
  }
`;
